module.exports = "https://www.svtstatic.se/play/play7/_next/static/images/atv-kollage-f9a40ce443f7ba0806ec3d225ff6bcd8.jpg";